import type { Block, BlockType } from '@ellie/shared';

/**
 * Maps block types to their CSS tag class and display label.
 */
const TAG_CONFIG: Record<BlockType, { className: string; label: string; icon: string }> = {
  vocabulary_grid: {
    className: 'wb-vocab',
    label: 'Vocabulary',
    icon: '\u{1F4DD}',
  },
  guided_conversation: {
    className: '',
    label: 'Conversation',
    icon: '\u{1F4AC}',
  },
  fill_in_the_blank: {
    className: 'wb-fill',
    label: 'Fill in the Blank',
    icon: '\u{270F}\u{FE0F}',
  },
  reading_comprehension: {
    className: 'wb-read',
    label: 'Reading',
    icon: '\u{1F4D6}',
  },
  matching_exercise: {
    className: 'wb-match',
    label: 'Matching',
    icon: '\u{1F517}',
  },
  scenario_prompts: {
    className: 'wb-scenario',
    label: 'Writing',
    icon: '\u{1F4AD}',
  },
  translation_challenge: {
    className: 'wb-translate',
    label: 'Translation',
    icon: '\u{1F504}',
  },
  conjugation_spotlight: {
    className: 'wb-conjugation',
    label: 'Conjugation',
    icon: '\u{1F526}',
  },
  grammar_explanation: {
    className: 'wb-grammar',
    label: 'Grammar',
    icon: '\u{1F4D0}',
  },
};

interface BlockHeaderProps {
  block: Block;
  index: number;
}

export function BlockHeader({ block }: BlockHeaderProps) {
  const config = TAG_CONFIG[block.type];

  return (
    <div className="wb-block-header">
      <span className={`wb-block-tag ${config.className}`}>{config.label}</span>
      <h2 className="wb-block-title">{block.title}</h2>
      {block.titleNative && <p className="wb-block-subtitle">{block.titleNative}</p>}
    </div>
  );
}
